interface Props {
  index: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

function ChevronUp() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M6 14l6-6 6 6"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronDown() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M6 10l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Кнопки ↑↓ как в Telegram — переход к более раннему / позднему совпадению. */
export function SearchNavigator({ index, total, onPrev, onNext }: Props) {
  if (total < 2) return null;

  return (
    <div className="search-nav-float" role="navigation" aria-label="Результаты поиска">
      <button
        type="button"
        className="search-nav-btn"
        onClick={onPrev}
        disabled={index <= 0}
        aria-label="Более раннее совпадение"
        title="Более раннее"
      >
        <ChevronUp />
      </button>
      <span className="search-nav-counter" aria-live="polite">
        {index + 1}/{total}
      </span>
      <button
        type="button"
        className="search-nav-btn"
        onClick={onNext}
        disabled={index >= total - 1}
        aria-label="Более позднее совпадение"
        title="Более позднее"
      >
        <ChevronDown />
      </button>
    </div>
  );
}
